import { SearchAllCity } from '../../apis/city/SearchCity';

export const CityService = {
  search: async () => {
    return await SearchAllCity();
  },
};
